<app-multi-select-btn 
    [label]="'Harvests'"
    [list]="harvests"
    [selected]="selected"
    (onClosed)="closedEvent($event)">
</app-multi-select-btn>